import React from 'react';
import { Box } from '@mui/material';
import { useStorageImageSrc } from '../../hooks/useStorageImageSrc';

/** Image that tries /api/storage/ then /storage/ when the first URL fails. */
const StorageImage = ({ storagePath, src, alt, sx, style, className, ...rest }) => {
  const path = storagePath ?? src;
  const raw = String(path || '').trim();
  const isDirect = raw.startsWith('data:') || raw.startsWith('blob:');
  const { src: resolvedSrc, onError } = useStorageImageSrc(isDirect ? null : path);

  return (
    <Box
      component="img"
      src={isDirect ? raw : resolvedSrc}
      alt={alt}
      onError={isDirect ? undefined : onError}
      className={className}
      sx={sx}
      style={style}
      {...rest}
    />
  );
};

export default StorageImage;
